import HttpRequestHandler from '@/plugins/http/index';
import { AgentService } from '@/services';

export default {
  setUser: ({ commit }, payload) => {
    commit('setUser', payload);
  },

  setUserInfo: ({ commit }, payload) => {
    commit('setUserInfo', payload);
  },

  login: ({ dispatch }, options) => {
    return AgentService.login(options)
      .then(response => {
        if (response.sessionId) {
          dispatch('setUser', {
            name: response.user.name,
            role: response.user.role,
            organizationId: response.organizationDetails.id,
            organizationName: response.organizationDetails.name,
            organizationAbbreviation: response.organizationDetails.abbreviation
          });
          HttpRequestHandler.setSessionId(response.sessionId);

          if (response.user.role === 'OrgAdmin') {
            return Promise.resolve({});
          } else {
            return AgentService.currentUserInfo();
          }
        } else {
          throw new Error('No sessionID provided by the service');
        }
      })
      .then(currentUser => {
        dispatch('setUserInfo', currentUser.data || null);
        return Promise.resolve();
      });
  }
};
